<template>
    <a-form-model :model="form" :rules="rules">
        <a-form-model-item prop="phone">
            <a-input v-model="form.phone" placeholder="请输入手机号" >
                <icon-phone slot="prefix" />
            </a-input>
        </a-form-model-item>
        <a-form-model-item>
            <a-input v-model="form.code" placeholder="请输入验证码">
                <icon-safety slot="prefix" />

                <div class="send-code-btn" slot="suffix">发送验证码</div>
            </a-input>
        </a-form-model-item>
    </a-form-model>
</template>

<script>
export default {
    data() {
        let validatePhone = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'));
            } else {
                let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                if (!reg_tel.test(this.form.phone)) {
                    callback(new Error('手机号有误'));
                }
                callback();
            }
        };

        return {
            form: { phone: '', code: '' },
            rules: {
                phone: [{ validator: validatePhone, trigger: 'blur' }]
            }
        };
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
::v-deep {
    .ant-form {
        .send-code-btn {
            position: relative;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #005bac;
            cursor: pointer;
            padding-left: 16px;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 16px;
                background: #d9d9d9;
            }
        }
    }
}
</style>
